import { supabase } from "../supabase";

const SESSION_KEY = "gatheryou_funnel_session";

// Per-tab, not per-device or per-account — a fresh value each time someone
// opens a new tab is fine, since this only needs to dedupe repeat events
// within one signup attempt (a reload mid-wizard re-firing "birthdate
// reached" shouldn't count as two people). Never tied to a real user id,
// since most of these events fire before an account exists.
function getSessionId() {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = crypto.randomUUID();
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return null; // private mode / blocked storage — just skip tracking
  }
}

// Fire-and-forget — must never block or interrupt the actual signup flow.
// A failure here (offline, RLS misconfigured before the SQL is run) is
// swallowed, not surfaced to the person signing up.
export function trackFunnelEvent(event) {
  const session_id = getSessionId();
  if (!session_id) return;
  supabase
    .from("signup_funnel_events")
    .insert({ session_id, event })
    .then(({ error }) => {
      if (error) console.log("FUNNEL TRACK ERROR:", error);
    });
}
